import { Component } from '@angular/core';
import { IconBase } from 'src/app/icons/icon.base';
import { IconConfig } from 'src/app/icons/icon.config';

@Component({
  selector: 'fit-text-bullet-list-icon',
  templateUrl: './text-bullet-list.component.html'
})
export class TextBulletListComponent extends IconBase {

  constructor(config?: IconConfig) {
    super(config);
  }
}
